<script>
import { Loading } from "element-ui";

export default {
  data() {
    return {
      form: {
        sku: "",
      },
      setList: [],
    };
  },
  // 创建完毕
  created() {
    this.getList(); // 获取低价产品列表
  },
  methods: {
    // 获取低价产品列表
    getList() {
      this.$axios.get("/a1/act/priceDowList").then((res) => {
        this.setList = res.data.data;
      });
    },
    // 提交设置价格
    submit() {
      // 加载中 提示
      const loadingInstance = Loading.service({
        text: "执行中，请稍候...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$axios.post("/a1/act/setPriceDow", this.form).then((res) => {
        loadingInstance.close();
        this.$alert("设置成功");
        this.getList();
        this.form.sku = "";
      });
    },
    // 重置
    reSetGoods() {
      // 加载中 提示
      const loadingInstance = Loading.service({
        text: "执行中，请稍候...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$axios.put("/a1/act/resetPriceDow", {}).then((res) => {
        loadingInstance.close();
        this.$alert("重置成功");
        this.getList();
        this.form.sku = "";
      });
    },
    // 删除对应的setList商品
    delOne(index) {
      let sku = this.setList[index];

      // 获取到要删除的商品sku
      // this.$alert(sku)
      this.$axios.delete(`/a1/act/delPriceDow/${sku}`).then(() => {
        this.setList.splice(index, 1);
        // this.getList()
      });
    },
  },
};
</script>

<template>
  <!-- 用于提交组建 -->
  <div>
    <div style="margin: 10px 0;">
      <el-button type="danger" @click="reSetGoods">把所有低价商品都重置</el-button>
    </div>
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="商品列表">
        <!-- 商品列表，用换行隔开 -->
        <el-input :rows="5" type="textarea" placeholder="商品列表，用换行隔开" v-model="form.sku"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="submit">提交</el-button>
      </el-form-item>
    </el-form>

    <div class="priceDow">
      <p>已在低价商品列表：</p>
      <ul>
        <!-- 循环100个 -->
        <li v-for="(item,index) in setList" :key="index">
          <el-tag style="height: 30px;line-height: 30px;" type="success">{{ item }}</el-tag>
          <!-- 删除 -->
          <el-button @click="delOne(index)" type="danger" size="mini" icon="el-icon-delete"></el-button>
        </li>
      </ul>
    </div>
  </div>
</template>

<style scoped lang="scss">
.priceDow {
  border: 1px solid #999595;
  max-height: 500px;
  overflow-y: scroll;
}

.priceDow ul {
  display: flex;
  flex-wrap: wrap;
}

.priceDow ul li {
  width: 150px;
  display: flex;
  margin: 10px;
  border: #F56C6C 1px solid;
  border-radius: 5px;
}
</style>